<template>
    <div class="com-avatar-container">
        <slot></slot>
        <img v-if="props.user?.vip_type" src="@/../images/vip-sign.png" class="vip-sign" :style="{
            width: props.vipSignWidth
        }"/>
    </div>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
    user: any,
    vipSignWidth?: string, //VIP标识的宽度
}>(), {
    vipSignWidth: '50%'
})
</script>

<style scoped lang="less">
.com-avatar-container {
    position: relative;

    .vip-sign {
        position: absolute;
        bottom: 0;
        right: -4px;
        pointer-events: none;
    }
}
</style>
